import React from 'react';
import { useEffect} from "react";
import '@/app/style/captionShowMore.scss';
import { useLanguage } from "@/app/utils/LanguageContext";

export const LANGTYPE_EN = "english";
 
const CaptionShowMore: React.FC<any> = (props: any) => {
  const {state:lang} = useLanguage();
  const {content, index,isDesktop, setNavigationButtonDisplay} = props;

  useEffect(()=>{
    const elementsinput = document.querySelectorAll('input[name="input_caption_text"]:checked');
    elementsinput.forEach(function(checkbox) {
      const cbElement =  checkbox as HTMLInputElement;
      cbElement.checked = false;
    });

    if(!content) {
      return
    }
    const reSetTextCss = (elementText: any) => {
      if(elementText)
      {
        const divElement = elementText as HTMLDivElement;
        const elementslabel = document.getElementById(`btnMore1_${index}`);
        divElement.classList.remove("caption-text-overflow");
        console.log("divElement.scrollHeight",divElement.scrollHeight,divElement.offsetHeight);
        if(divElement.scrollHeight-divElement.offsetHeight > 16)
        {
          //divElement.classList.add("caption-text-overflow");
          elementslabel?.classList.remove("btnMoreHide");
        }else{
          //divElement.classList.remove("caption-text-overflow");
          elementslabel?.classList.add("btnMoreHide"); 
        }
        divElement.classList.add("caption-text-overflow");
      }
    }
    const observer = new ResizeObserver(entries => {
      for (let entry of entries) {
        reSetTextCss(entry.target)
      }
    });

    const targetElement = document.getElementById(`caption_text_${index}`);
    
    if(targetElement)
    {
      reSetTextCss(targetElement);
      observer.observe(targetElement);
    }

    return () => {
      if(targetElement) {
        observer.unobserve(targetElement);
      }
        
    }
    
  }, [content])


  return (
    <div className="caption-content-wrapper" style={{display: content ? undefined: 'none'}}>
        <input id={`exp_id_${index}`} name="input_caption_text" className="exp-input-more" type="checkbox"></input>
        <div id={`caption_text_${index}`} className={`caption-text ${isDesktop?"":"caption-text-mobile"}`}>
            <label id={`btnMore1_${index}`} onClick={(e) =>setNavigationButtonDisplay('showmore')}  className={`btnMore btnMore1 btnMoreHide ${lang.langType === LANGTYPE_EN?"":"btnMore-ch"}`} htmlFor={`exp_id_${index}`}></label>
            {content}
            <label onClick={(e) =>setNavigationButtonDisplay('showless')} className={`btnMore btnMore2 ${lang.langType === LANGTYPE_EN?"":"btnMore-ch"}`} htmlFor={`exp_id_${index}`}></label>
        </div>
    </div>
  );
};
 
export default CaptionShowMore